/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelinePlacementKindDto } from './traveline-placement-kind-dto';
import {
    TravelinePlacementKindDtoFromJSON,
    TravelinePlacementKindDtoFromJSONTyped,
    TravelinePlacementKindDtoToJSON,
    TravelinePlacementKindDtoToJSONTyped,
} from './traveline-placement-kind-dto';

/**
 * Accommodation in a room
 * @export
 * @interface TravelineBookingPlacementRsDto
 */
export interface TravelineBookingPlacementRsDto {
    /**
     * String representation of accommodation
     * @type {string}
     * @memberof TravelineBookingPlacementRsDto
     */
    code: string;
    /**
     * Number of accommodations
     * @type {number}
     * @memberof TravelineBookingPlacementRsDto
     */
    count: number;
    /**
     * 
     * @type {TravelinePlacementKindDto}
     * @memberof TravelineBookingPlacementRsDto
     */
    kind: TravelinePlacementKindDto;
    /**
     * Minimum age in the age group<br />
     * Specified for child accommodation only<br />
     * (Kind = Child | ExtraChild | ChildBandWithoutBed)
     * @type {number}
     * @memberof TravelineBookingPlacementRsDto
     */
    minAge?: number | null;
    /**
     * Maximum age in the age group<br />
     * Specified for child accommodation only<br />
     * (Kind = Child | ExtraChild | ChildBandWithoutBed)
     * @type {number}
     * @memberof TravelineBookingPlacementRsDto
     */
    maxAge?: number | null;
}



/**
 * Check if a given object implements the TravelineBookingPlacementRsDto interface.
 */
export function instanceOfTravelineBookingPlacementRsDto(value: object): value is TravelineBookingPlacementRsDto {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    return true;
}

export function TravelineBookingPlacementRsDtoFromJSON(json: any): TravelineBookingPlacementRsDto {
    return TravelineBookingPlacementRsDtoFromJSONTyped(json, false);
}

export function TravelineBookingPlacementRsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineBookingPlacementRsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'count': json['count'],
        'kind': TravelinePlacementKindDtoFromJSON(json['kind']),
        'minAge': json['minAge'] == null ? undefined : json['minAge'],
        'maxAge': json['maxAge'] == null ? undefined : json['maxAge'],
    };
}

  export function TravelineBookingPlacementRsDtoToJSON(json: any): TravelineBookingPlacementRsDto {
      return TravelineBookingPlacementRsDtoToJSONTyped(json, false);
  }

  export function TravelineBookingPlacementRsDtoToJSONTyped(value?: TravelineBookingPlacementRsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'count': value['count'],
        'kind': TravelinePlacementKindDtoToJSON(value['kind']),
        'minAge': value['minAge'],
        'maxAge': value['maxAge'],
    };
}

